import {useCallback, useState} from "react"

export const useRerender = () => {
    const [_, forceUpdate] = useState(0)
    const rerender = useCallback(() => forceUpdate((x) => (x + 1) % 100), [])
    return rerender
}
